// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx"}[chunkId] + "-" + {"218":"0a8c820cf18140b76136","691":"380f99ad67dc42ceec9b"}[chunkId] + ".js";
};